<div *ngIf="collaboratorReports.length > 0" class="report-list font-dm-sans">
  <div class="overflow-x-auto">
    <div class="table-shell">
      <table class="report-table">
        <colgroup>
          <col class="report-table__col report-table__col--company" />
          <col class="report-table__col report-table__col--subsidiary" />
          <col class="report-table__col report-table__col--name" />
          <col class="report-table__col report-table__col--card-status" />
          <col class="report-table__col report-table__col--has-card" />
        </colgroup>

        <thead class="border-b border-gray-400">
          <tr>
            <th scope="col" class="text-left">Empresa</th>
            <th scope="col" class="text-left">Filial</th>
            <th scope="col" class="text-left">Funcionário</th>
            <th scope="col" class="text-center">Situação</th>
            <th scope="col" class="text-center">Tem Cartão Ativo</th>
          </tr>
        </thead>

        <tbody>
          <tr class="report-table__row" *ngFor="let report of collaboratorReports">
            <td>
              <span class="cell-main cell-ellipsis" [title]="report.companyName || '-'">
                {{ report.companyName || '-' }}
              </span>
            </td>
            <td>
              <span class="cell-main cell-ellipsis" [title]="report.subsidiaryName || '-'">
                {{ report.subsidiaryName || '-' }}
              </span>
            </td>
            <td>
              <span class="cell-main cell-ellipsis" [title]="report.employeeName || '-'">
                {{ report.employeeName || '-' }}
              </span>
            </td>
            <td class="text-center">
              <span>
                {{ statusLabel(report.status) || '-' }}
              </span>
            </td>
            <td class="text-center">
              <span
                class="cell-badge"
                [ngClass]="report.hasActiveCard ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
              >
                {{ report.hasActiveCard ? 'Sim' : 'Não' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-no-results-found [condition]="collaboratorReports.length === 0"></app-no-results-found>

<div class="pagination-wrapper">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
